import React from "react";
import { Link } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import { Results_NavLink_To } from "../../Constants/AppBar";

//common search component for POC1 displaying a hard-coded string.
const sampleSearchTerm = "lowes asset";
const commonSearchesTxt = "Sample Search";
const useStyles = makeStyles((theme) => ({
  root: {
    position: "absolute",
    top: "4em",
    left: "-12em",
  },
  large: {
    width: "7em",
    height: "7em",
  },
}));
const CommonSearch = () => {
  const classes = useStyles();

  const history = useHistory();

  const handleClick = () => {
    // navigating user to search results page, when user clicks on common search link.
    history.push({
      pathname: Results_NavLink_To + "/" + sampleSearchTerm,
    });
  };
  return (
    <div className={classes.root}>
      <span>{commonSearchesTxt}</span>
      <div>
        <Link color="primary" onClick={handleClick}>
          {sampleSearchTerm}
        </Link>
      </div>
    </div>
  );
};

export default CommonSearch;
